import React, { useState, useEffect, useContext } from "react";
import menuIcon from "../../Assets/icons/Sidebaricon/panel-right-close.svg";
import { Switch } from "antd";
import "./style.css";
import { ThemeContext } from "../../Contexts/ThemeProvider";

const PageLayout = ({ pageName, children, collapsed, setCollapsed }) => {
  const { isDarkMode, toggleTheme } = useContext(ThemeContext);

  return (
    <div className="admin-page">
      <div className="header-layout">
        <div className="left">
          <div className="panel-right">
            <img
              className="panel-icon"
              src={menuIcon}
              alt="Toggle Sidebar"
              onClick={() => setCollapsed(!collapsed)}
            />
          </div>

          <div className="vertical-line"></div>
          <div className="page-title">{pageName}</div>
        </div>
        <div className="theme-toggle-container">
          <span className="theme-label">{isDarkMode ? "Dark" : "Light"}</span>
          <Switch checked={isDarkMode} onChange={toggleTheme} />
        </div>
      </div>

      <div className="horizontal-line" />
      <div className="page-content">{children}</div>
    </div>
  );
};

export default PageLayout;
